/**
 * 全局action函数
 */

import axios from "../utils/axios";
import localstore from "../utils/localStorge";

let actions = {
  deviceClass({ commit }) {
    if (localstore.get("deviceClass")) {
      commit("setDeviceClass", {
        deviceClass: localstore.get("deviceClass")
      });
      return;
    }
    return new Promise((resolve, reject) => {
      axios.get("https://backend.farmapi.xiaomaiot.com/device_data/list")
      .then(res => {
        if (res.status === 200) {
          localstore.set("deviceClass", res.data.data);
          commit("setDeviceClass", {
            deviceClass: res.data.data
          });
        }
        resolve();
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  },
  roomList({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(`/room_list?farm_id=${state.farmId}`)
      .then(res => {
        if (res.status === 200) {
          commit("setRoomList", {
            roomList: res.data.data
          });
        }
        resolve();
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  },
  fruitCategory({commit}) {
    if (localstore.get("fruitCategory")) {
      commit("setFruitCategory", {
        fruitCategory: localstore.get("fruitCategory")
      });
    }
    return new Promise((resolve, reject) => {
      // 上一个月时间
      let date = new Date();
      let month = date.getMonth() === 0 ? 12 : date.getMonth();
      axios.get(`/price/species?month=${month}`)
      .then(res => {
        if(res.status === 200) {
          localstore.set("fruitCategory", res.data.data);
          commit("setFruitCategory", {
            fruitCategory: res.data.data
          });
        }
        resolve();
      })
      .catch(error => {
        console.error(error);
        reject();
      });
    });
  }
};

export default actions;
